// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1guwf","top":"styles_top__2MkBj"};